import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { addressCharacters } from '@parchment/validation-utils';
import ComposedTextField from '../ComposedField/ComposedTextField';
import ComposedSelectField from '../ComposedField/ComposedSelectField';
export default function Country(_ref) {
  let {
    name = 'country',
    label = 'Country',
    autoComplete = 'country',
    validators = [{
      message: 'Please enter a valid Country',
      callback: addressCharacters
    }],
    value = undefined,
    visited: visitedProp = false,
    options = [],
    ...props
  } = _ref;
  const [visited, setVisited] = useState(visitedProp);
  const commonProps = {
    ...props,
    name,
    placeholder: label,
    autoComplete,
    validators,
    visited,
    onFocus: () => undefined,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onBlur: e => {
      setVisited(true);
      props.onBlur && props.onBlur(e);
    }
  };
  if (options.length > 0) {
    return /*#__PURE__*/React.createElement(ComposedSelectField, _extends({}, commonProps, {
      onFocus: () => undefined,
      options: options,
      value: value
    }));
  }
  return /*#__PURE__*/React.createElement(ComposedTextField, _extends({}, commonProps, {
    value: value || ''
  }));
}